'use es6';

import * as RefundStatusTypes from '../constants/RefundStatusTypes';
export var isPending = function isPending(refund) {
  return refund && refund.get('status') === RefundStatusTypes.PENDING;
};
export var isSubmitted = function isSubmitted(refund) {
  return refund && refund.get('status') === RefundStatusTypes.SUBMITTED;
};
export var isSucceeded = function isSucceeded(refund) {
  return refund && refund.get('status') === RefundStatusTypes.SUCCEEDED;
};
export var isFailed = function isFailed(refund) {
  return refund && refund.get('status') === RefundStatusTypes.FAILED;
};
export var isCanceled = function isCanceled(refund) {
  return refund && refund.get('status') === RefundStatusTypes.CANCELED;
};